import React from 'react';
import './MyMarker.css';

const MyMarker = ({ text, tooltip, $hover }) => (
  <div className={$hover ? 'circle hover' : 'circle'}>
    <span className="circleText" title={tooltip}>
      {text}
    </span>
  </div>
);

export default MyMarker;
